import { render, staticRenderFns } from "./GiftCardStatus.vue?vue&type=template&id=089c3a2a&"
import script from "./GiftCardStatus.vue?vue&type=script&lang=js&"
export * from "./GiftCardStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports